export default __webpack_public_path__ + "static/media/soulvirtue_logo.6d56fb94.svg";